import { useLocaleContext } from '../contexts/LocaleContext';

export const useLocale = () => {
  const context = useLocaleContext();
  
  return {
    // State
    locale: context.locale,
    messages: context.messages,
    loading: context.loading,
    error: context.error,
    supportedLocales: context.supportedLocales,
    
    // Actions
    setLocale: context.setLocale,
    t: context.t,
    formatDate: context.formatDate,
    formatNumber: context.formatNumber,
    formatCurrency: context.formatCurrency,
    getTextDirection: context.getTextDirection,
    
    // Computed values
    isRTL: context.isRTL,
    
    // Convenience methods
    translate: context.t, // Alias for t
    changeLanguage: context.setLocale, // Alias for setLocale
    
    // Locale checks
    isEnglish: context.locale === 'en',
    
    // Formatting shortcuts with common options
    formatShortDate: (date) => context.formatDate(date, { 
      year: 'numeric', 
      month: 'short', 
      day: 'numeric' 
    }),
    
    formatLongDate: (date) => context.formatDate(date, { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    }),
    
    formatTime: (date) => context.formatDate(date, { 
      hour: '2-digit', 
      minute: '2-digit' 
    }),
    
    formatDateTime: (date) => context.formatDate(date, { 
      year: 'numeric', 
      month: 'short', 
      day: 'numeric',
      hour: '2-digit', 
      minute: '2-digit' 
    }),
    
    formatPercentage: (number) => context.formatNumber(number, { 
      style: 'percent' 
    }),
    
    formatDecimal: (number, decimals = 2) => context.formatNumber(number, { 
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals
    })
  };
};